var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencilGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit / undefined / Glyph: undefined"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.0565 3.13654C17.8336 1.85548 15.8511 1.85553 14.6283 3.13668L4.17203 14.0922C3.81649 14.4647 3.56659 14.9332 3.45013 15.4456L2.49149 19.6637C2.43871 19.896 2.50471 20.1402 2.66585 20.309C2.827 20.4779 3.06021 20.547 3.2819 20.4917L7.30799 19.4875C7.79729 19.3654 8.24466 19.1035 8.6003 18.7309L19.0566 7.77534C20.2793 6.49431 20.2793 4.41749 19.0565 3.13654ZM15.5565 4.10888C16.2666 3.36478 17.4182 3.36474 18.1284 4.10881C18.8386 4.85281 18.8387 6.05907 18.1285 6.80312L17.3486 7.62028L14.7767 4.92589L15.5565 4.10888ZM13.8486 5.89822L16.4206 8.59261L7.67217 17.7587C7.48829 17.9513 7.25698 18.0867 7.00399 18.1499L4.0153 18.8953L4.72694 15.7642C4.78715 15.4992 4.91635 15.257 5.10016 15.0644L13.8486 5.89822Z",
    fill: "#ABABAB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilGray);
export default __webpack_public_path__ + "static/media/pencil-gray.b17162ebce126c83152086ba7f4d58d6.svg";
export { ForwardRef as ReactComponent };